export const JobPositions = {
    // SEO-специалист
    SEO: 1,
    // Маркетолог
    MARKET: 2,
    // Специалист по контекстной рекламе
    ADS: 3,
    // Копирайтер/автор
    COPYWRITER: 4,
    // Веб-мастер
    WEB: 5,
    // Аналитик
    ANALYST: 6,
    // Руководитель проекта
    MANAGER: 7,
    // Предприниматель
    EMPLOYER: 8,
}
